





























import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class NotFound extends Vue {

  public mounted() {
    document.body.classList.add('external-error', 'NotFound');
  }

}
